import React from 'react';

import { RESOURCE_TO_API } from 'Constants';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import { SevenOpteamRoute } from 'types/seven-opteam-route';
import { Visit } from 'types/visits';

import { compareSevenOpteamActivity } from 'utils/visits';

import { get } from './http';

export const useSevenOpteamVisitList = (
  repairmanId: number,
  visitDate: string
): { visitList: Visit[]; loadingVisits: boolean } => {
  const url = `/${RESOURCE_TO_API['seven-opteam-route']}/${repairmanId}/${visitDate}/`;
  const { data: visitList, isLoading: loadingVisits } = useQuery<
    SevenOpteamRoute,
    unknown,
    Visit[]
  >([url], () => get(url), {
    select: (data) => data?.stops.sort(compareSevenOpteamActivity),
  });

  return {
    visitList: visitList || [],
    loadingVisits,
  };
};

export const useSearchParams = (): URLSearchParams => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
